import { gql } from "@apollo/client";

const UPDATE_TRAINEESHIP_TABLE_D = gql`
  mutation UpdateTraineeshipTableD(
    $traineeshipID: String!
    $tableDData: TableDInput!
    $email: String!
    $name: String!
    $position: String!
  ) {
    updateTraineeshipTableD(
      traineeshipID: $traineeshipID
      tableDData: $tableDData
      email: $email
      name: $name
      position: $position
    )
  }
`;

export default UPDATE_TRAINEESHIP_TABLE_D;